<template>
	<div class="condition-editor">
		<span class="editor-input" ref="conditionEditor"/>
		<span class="actions">
			<a @click.stop.prevent="$emit('remove')" class="action" href>
				<i class="fa-light fa-trash"></i>
			</a>
			<a @click.stop.prevent="$emit('add')" class="action" href>
				{{$t('condition-editor.condition')}}
			</a>
			<span v-if="isParsing">..</span>
			<span v-else-if="!isValid">!!</span>
		</span>
	</div>
</template>

<script>

	// THIS WHOLE THING IS A TEMPORARY SOLUTION UNTIL WE IMPLEMENT THE CONDITION-EDITOR

	import Quill from 'quill'
	import EventBus from '@/assets/js/eventBus.js'
	import VariableHelpers from '@/assets/js/variableHelpers.js'

	export default {
		props: {
			condition: {
				type: Object,
				required: true
			}
		},
		data() {
			return {
				editor: null,
				invalidVariables: [],
				parsingError: false,
				isParsing: false
			}
		},
		methods: {
			onBeginEdit() {
				this.$nextTick(() => {
					this.editor = this.initializeEditor()
					// split text and variables into their respective blots
					let vars = VariableHelpers.findInText(this.condition.expression)
					let conditionWithoutVars = this.condition.expression.split(VariableHelpers.pattern)
					let contents = []
					conditionWithoutVars.forEach(((text, index) => {
						if (text !== '') contents.push({insert: text}) // could be "" if sentence starts or ends with a variable => so skip.
						if (vars && vars[index] !== undefined) {
							let variable = VariableHelpers.getByName(vars[index], this.$store.getters.combinedVariables)
							contents.push({
								insert: {
									variable: {
										formatting: VariableHelpers.getFormatting(vars[index]), ...variable
									}
								}
							})
						}
					}).bind(this))
					this.editor.setContents(contents)
					this.editor.focus()
				})
			},
			initializeEditor() {
				let editor = new Quill(this.$refs.conditionEditor, {
					debug: 'error',
					placeholder: 'Ingen visningsbetingelser..',
					formats: ['variable']
				})
				let that = this
				editor.on('text-change', (delta, oldDelta, source) => {
					if (source == 'user') { // do not react to our changes, only the user's
						// build the new changed condition from editor contents.
						let condition = editor.getContents().ops.map(operation => {
							if (operation.insert.variable) { // is a variable
								if (operation.insert.variable.formatting) return VariableHelpers.insertFormatting(operation.insert.variable.name, operation.insert.variable.formatting)
								else return operation.insert.variable.name
							} else return operation.insert // plain text
						}).join('')

						// check if condition contains invalid variables
						that.invalidVariables = (VariableHelpers.findInText(condition) || []).filter(v => !VariableHelpers.getByName(v, that.$store.getters.combinedVariables))

						if (that.invalidVariables.length == 0 && condition) {
							that.condition.expression = condition.trim()
						}
					}
				})

				// when clicking outside the editor, save if valid, warn if invalid.
				editor.root.addEventListener('blur', () => {
					setTimeout(() => {
						if (this.isValid) this.$emit('done')
						else {
							console.log('invalid or parsing, cannot save')
							editor.root.focus()
						}
					}, 200)
				})
				return editor
			},
		},
		computed: {
			expression() {
				return this.condition.expression
			},
			isValid() {
				if (this.isParsing) return false
				if (this.parsingError) return false
				if (this.invalidVariables.length > 0) return false
				return true
			}
		},
		watch: {
			expression(expression) {
				console.log('expression: ' + expression)
				this.isParsing = true
				let onDone = (lastExpression, wasSuccess) => {
					if (this.expression == lastExpression) {
						this.parsingError = !wasSuccess
						this.isParsing = false
						console.log('Parsing result', wasSuccess ? 'Success' : 'Failed')
					}
				}
				EventBus.$emit('templateChange', {
					onSuccess: () => onDone(expression, true),
					onError: () => onDone(expression, false)
				})
			}
		},
		mounted() {
			this.onBeginEdit()
		}
	}
</script>

<style lang="less">
	span.variable {
		text-decoration: underline;
	}

	.condition-editor {
		color: #8F979C;
		// padding-left: 0 !important;
		line-height: 24px;
		word-break: break-word;
		display: flex;
		position: relative;
		background-color: rgba(143, 151, 156, .3);

		.editor-input {
			flex: 1 1 auto;
		}

		.actions {
			flex: 0 0 auto;
			margin-left: 15px;

			.action {
				margin-right: 15px;
			}

			span {
				margin-right: 15px;
			}
		}

		.ql-container {
			flex: 1 1 auto;
			font-family: 'Roboto', sans-serif;
			font-size: 14px;

			.ql-editor {

				padding: 0 0 0 40px;
				// display: inline !important;

				&.ql-blank::before {
					left: 0;
				}

				p {
					display: inline !important;
				}

				span.variable-blot {
					text-decoration: underline;
					cursor: pointer;
					// &:not(:first-child) {
					// 	margin-left: 15px;
					// }

					// margin-right: 15px;

				}
			}
		}
	}
</style>

